export enum OrderProviderSyncJobStatus {
  CREATED = 'created',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  DONE = 'done',
}
